// extracted by mini-css-extract-plugin
export default {"formItem":"style_formItem__U2Xo8","formItemLabel":"style_formItemLabel__5jtW8","star":"style_star__xU80I"};